import i8n from "@/i18n";
import { Site } from "leatherman-js/models";
import store from "@/store";

const handler = (event, data) => {
  switch (event) {
    case "app-environment:delete":
      store.dispatch("sites/refreshListBySiteId", data.service.cloud_account.reference_account_id);
      break;
    case "virt-guest-cloudaccount:add":
      let addedSite = Site.formatLegacy(data);
      if (["development", "staging"].includes(addedSite.environmentType)) {
        store.dispatch("devSites/refreshList", { parentSiteId: addedSite.referenceAccount.id });
      } else {
        store.dispatch("sites/refreshList", { planId: addedSite.plan.id });
        store.dispatch("plans/refreshItem", addedSite.plan.id);
      }

      store.dispatch("toasts/addToast", {
        variant: "info",
        message: i8n.t("toasts.site-adding-message", { name: data.domain }),
      });
      break;
    case "virt-guest-cloudaccount:delete":
      let deletedSite = Site.formatLegacy(data);

      if (["development", "staging"].includes(deletedSite.environmentType)) {
        if (deletedSite.referenceAccount) {
          store.dispatch("devSites/refreshList", { parentSiteId: deletedSite.referenceAccount.id });
        }
      } else {
        store.dispatch("sites/refreshList", { planId: deletedSite.plan.id || data.service_id });
        store.dispatch("plans/refreshItem", deletedSite.plan.id || data.service_id);
      }

      store.dispatch("devSites/refreshListByDevSiteId", data.id);

      // This is a hack to identify a regression site. The websocket event does not have any
      // data that pertains to the site environment to check if its regression.
      if (!deletedSite.domain.startsWith("reg-")) {
        store.dispatch("toasts/addToast", {
          variant: "info",
          message: i8n.t("toasts.site-removed-message", { name: deletedSite.domain }),
        });
      }
      break;
    case "virt-guest-cloudaccount:update":
      const updatedSite = Site.formatLegacy(data);

      store.dispatch("plans/refreshPrimarySite", data.id);
      store.dispatch("sites/refreshList", { planId: data.service_id });

      if (["development", "staging"].includes(updatedSite.environmentType)) {
        store.dispatch("devSites/refreshList", { parentSiteId: updatedSite.referenceAccount.id });
        store.dispatch("devSites/refreshItem", data.id);
        store.dispatch("sites/refreshListBySiteId", data.reference_account_id);
      } else {
        store.dispatch("sites/refreshListBySiteId", data.id);
        store.dispatch("sites/refreshItem", data.id);
        store.dispatch("devSites/refreshItem", data.id);
      }

      if (data.reference_account_id) {
        store.dispatch("devSites/refreshList", { parentSiteId: data.reference_account_id });
      }
      break;
    case "virt-guest-containergroup:update":
      store.dispatch("containers/update", data.account_id);
      if (data.type?.service === "php" || data.type?.identity === "php") {
        store.dispatch("sites/refreshAdvancedAutoScale");
      }
      break;
    case "virt-guest-containergroup:delete":
      store.dispatch("containers/refreshList");
      if (data.type?.service === "php" || data.type?.identity === "php") {
        store.dispatch("sites/refreshAdvancedAutoScale");
      }
      break;
    case "api-task:add":
      if (data.resource_scope === "virt-guest-cloudaccount") {
        if (
          data.action === "cloud-account:set-newrelic-key" ||
          data.action === "cloud-account:clear-newrelic-key"
        ) {
          store.dispatch("sites/addNewRelicUpdate", data.resource_id);
        }
      }
      break;
    case "api-task:update":
      if (data.resource_scope === "virt-guest-cloudaccount") {
        if (data.identity.includes("portal.v1.cloud-account-advanced-autoscale")) {
          store.dispatch("sites/refreshAdvancedAutoScale", { id: data.resource_id });
        }
        if (
          data.identity.includes("cloud-account:set-newrelic-key") ||
          data.identity.includes("cloud-account:clear-newrelic-key")
        ) {
          store.dispatch("sites/refreshNewRelic", data.resource_id);
          if (data.identity.includes("cloud-account:set-newrelic-key (success)")) {
            store.dispatch("sites/removeNewRelicUpdate", data.resource_id);
            store.dispatch("toasts/addToast", {
              variant: "success",
              message: i8n.t("toasts.new-relic-enable-success-message"),
            });
          }
          if (data.identity.includes("cloud-account:clear-newrelic-key (success)")) {
            store.dispatch("sites/removeNewRelicUpdate", data.resource_id);
            store.dispatch("toasts/addToast", {
              variant: "success",
              message: i8n.t("toasts.new-relic-disable-success-message"),
            });
          }
        }
      }
      break;
    case "cron-options:change":
      store.dispatch("siteCron/refreshOptions");
      break;
    case "cron:change":
      store.dispatch("siteCron/refreshTasks");
      break;
    case "primary-domain:error":
      store.dispatch("toasts/addToast", {
        variant: "error",
        message: i8n.t("toasts.modify-master-domain-error-message", { domain: data?.domain }),
      });
    case "primary-domain:change":
      store.dispatch("letsencrypt/refreshDomains");
      store.dispatch("pointerDomains/refreshList");
      break;
  }
};

export default handler;
